import React, { FC } from "react";

import { IFlightDestination } from "../../../../../../logic/api";

interface AirportResultProps {
    item: IFlightDestination,
    selectAirport: (item: IFlightDestination) => void,
}

const AirportResult: FC<AirportResultProps> = ({ item, selectAirport }: AirportResultProps) => {
    if (!item.iata) {
        return null;
    }

    return <div onClick={() => selectAirport(item)} style={{ padding: 10, backgroundColor: "#fff", borderBottom: "solid 1px lightgray", cursor: "pointer", textAlign: "left" }}>
        <div>{item.name} <span>({item.iata})</span></div>
        <div style={{ color: "black", opacity: 0.4, fontWeight: 400 }}>{item.city}</div>
    </div>
}

export default AirportResult;
